import type { Observable } from 'rxjs';
import { EMPTY, of } from 'rxjs';

const localStorageSupported = window.localStorage !== undefined;

export interface ILocalStoragePersistApi {
  save<T>(data: T): Observable<T>;
}

export interface ILocalStorageLoadApi {
  load<T>(): Observable<T>;
}

export const localStorageApiConnector = <T>(
  key: string,
  defaultValue: Partial<T>,
): ILocalStorageLoadApi & ILocalStoragePersistApi => ({
  save<T>(data: T) {
    if (!localStorageSupported) {
      return EMPTY;
    }
    const serializedData = JSON.stringify(data);
    window.localStorage.setItem(key, serializedData);
    return of<T>({
      ...(<T>defaultValue),
      ...(serializedData ? <T>JSON.parse(serializedData) : {}),
    });
  },
  load<T>() {
    if (!localStorageSupported) {
      return EMPTY;
    }
    const serializedData = window.localStorage.getItem(key);
    return of<T>({
      ...(<T>defaultValue),
      ...(serializedData ? <T>JSON.parse(serializedData) : {}),
    });
  },
});
